<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CPlejs/tc-custom/cover.jpg?1684975141774?1696024732416" alt="This image is the cover for the book The Message of Samuel, The Bible Speaks Today Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Message of Samuel, The Bible Speaks Today Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Reading the books of 1 and 2 Samuel, we witness the transition of Israel from tribal confederacy to established monarchy. And, as Mary Evans shows in this passage-by-passage BST commentary, during such a transition questions of identity and power are unavoidable. In the aftermath of the decline of the judges, priests abuse their priestly privileges; a people covets the centralized authority of its impious neighbors; and a throne is won, forsaken, redeemed, lost and found again. But in the key characters in this dawning era of Israelite history we see, hidden behind the faults and failings of Israel's best and brightest, the faithfulness of a God who looks on the heart and directs the path of every king and every kingdom.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary J. Evans
      </h2>
      
      <p class="authorDescription body article"><em>1 and 2 Samuel</em><em>Woman in the Bible,</em><em>The IVP Women's Bible Commentary.</em></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?59d1c8c4